let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fsjNN")).then(() => parcelRequire('a8AXq'));